import * as React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next'
import { checklistUpdateComponent } from '../../../../redux/actions'
import FormComponentBuilder, { FormComponentBuilderChildrenProps } from '../FormComponent/FormComponentBuilder'
import { useState } from 'react'

export interface ComponentData {
  id: string
  optional: boolean
  type: {
    type: string
    value: number
  }
  defaultValue: number
  lastValue: number
}

export interface StateProps {
  componentData: ComponentData
  checklistInstanceId: string
  checkId: string
}

export interface OwnProps {
  collapseHandler?: Function
}

export type Props = StateProps & OwnProps & WithTranslation

export class CalculatorComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    this.manageCollapsable()
  }

  private manageCollapsable() {
    if (
      this.props.componentData.lastValue !== this.props.componentData.defaultValue &&
      this.props.componentData.optional &&
      this.props.collapseHandler
    ) {
      this.props.collapseHandler()
    }
  }

  public render() {
    return (
      <div className="collapse cl-controls-optional cl-controls-optional-1 show">
        <FormComponentBuilder<number> component={this.props.componentData} className={'text-left'}>
          {props => {
            return (
              <>
                <label htmlFor={`${this.props.componentData.id}-value`}>
                  {this.props.t('checklist.components.number.value')}
                </label>
                <_Input
                  {...props}
                  checklistInstanceId={this.props.checklistInstanceId}
                  componentId={this.props.componentData.id}
                />
              </>
            )
          }}
        </FormComponentBuilder>
      </div>
    )
  }
}

function _Input(
  props: FormComponentBuilderChildrenProps<number> & { checklistInstanceId: string; componentId: string }
): JSX.Element {
  const [internalValue, setInternalValue] = useState<string>(props.value?.toString())
  const dispatch = useDispatch()
  const { t } = useTranslation()

  React.useEffect(() => {
    setInternalValue(props.value?.toString())
  }, [props.value])

  const updateComponent = React.useCallback((event: React.FocusEvent<HTMLInputElement>) => {
    event.persist()
    const value = convertNumber(event.target.value)
    setInternalValue(value.toString())
    dispatch(checklistUpdateComponent(props.checklistInstanceId, props.componentId, value, false))
    props.onBlur()
  }, [])

  const onChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setInternalValue(event.target.value)
  }, [])

  const convertNumber = React.useCallback((value: string) => {
    const num = parseInt(value, 10)
    if (isNaN(num)) {
      return 0
    }
    return num
  }, [])

  return (
    <input
      type="number"
      min="0"
      step="1"
      id={`${props.componentId}-value`}
      className={`form-control jcalculator ${props.className}`}
      placeholder={t('checklist.components.number.value')}
      onBlur={updateComponent}
      disabled={props.disabled}
      value={internalValue}
      onChange={onChange}
    />
  )
}

export default withTranslation()(CalculatorComponent)
